// Whether the user has interacted with the matter sidebar since the last full
// page load. Module-level, so it RESETS on a hard refresh but SURVIVES in-app
// (SPA) navigation. That distinction is exactly what lets a hard refresh present
// the fully-collapsed default — all folders closed, Archived section closed —
// while in-session clicks still auto-reveal the selected matter and persist
// folder open-state (Ken 2026-08-19).
//
// It is deliberately NOT React state: these are pre-render gates read inside
// effects, and we never want a re-render when it flips.

let interacted = false

export function sidebarUserInteracted(): boolean {
  return interacted
}

export function markSidebarInteracted(): void {
  interacted = true
}
